import type {
  AceConversation,
  CraveDocSubmission,
  ExternalApply,
  JSTAceConversationResult,
  JSTCraveDocSubmissionResult,
  JSTExternalApplyResult,
  JSTModalScreen,
  JSTNbaOverviewResult,
  JSTOpenModalResult,
  JSTResumeGlowupResult,
  JSTSourcingOptInResult,
  JSTViewJobResult,
  JSTWebViewResult,
  NbaOverview,
  ResumeGlowup,
  SourcingOptIn,
  ViewJob,
  WebView,
} from "./JSTModalScreen";

import TypedNativeModules from "../internal/TypedNativeModules";

export function openModal(modalScreen: ViewJob, from: string | null): Promise<JSTViewJobResult>;
export function openModal(
  modalScreen: AceConversation,
  from: string | null,
): Promise<JSTAceConversationResult>;
export function openModal(
  modalScreen: CraveDocSubmission,
  from: string | null,
): Promise<JSTCraveDocSubmissionResult>;
export function openModal(
  modalScreen: ExternalApply,
  from: string | null,
): Promise<JSTExternalApplyResult>;
export function openModal(
  modalScreen: NbaOverview,
  from: string | null,
): Promise<JSTNbaOverviewResult>;
export function openModal(
  modalScreen: SourcingOptIn,
  from: string | null,
): Promise<JSTSourcingOptInResult>;
export function openModal(modalScreen: WebView, from: string | null): Promise<JSTWebViewResult>;
export function openModal(
  modalScreen: ResumeGlowup,
  from: string | null,
): Promise<JSTResumeGlowupResult | void>;
export function openModal(
  modalScreen: JSTModalScreen,
  from: string | null,
): Promise<JSTOpenModalResult | void>;
export async function openModal(
  modalScreen: JSTModalScreen,
  from: string | null,
): Promise<
  | void
  | JSTViewJobResult
  | JSTAceConversationResult
  | JSTCraveDocSubmissionResult
  | JSTExternalApplyResult
  | JSTNbaOverviewResult
  | JSTSourcingOptInResult
  | JSTWebViewResult
  | JSTResumeGlowupResult
  | JSTOpenModalResult
> {
  return await TypedNativeModules.RNJSTNavigator?.openModal?.(modalScreen, from);
}
